// Investment Performance: the routes and the sidebar rows of `wealth.intelligence.investment-performance` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.investment-performance',
    routes: [
        {
            frontend: 'view',
            path: 'investment-performance',
            lazy: () => import('@/pages/view/investment-performance/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'investment-performance',
            label: 'Investment Performance',
            href: '/view/investment-performance',
            icon: 'LineChart',
            group: 'performance',
            order: 220,
        },
    ],
});
